<template>
  <div
    class="action-popup absolute bg-white rounded  py-2 px-2 inset-3"
    :class="[width ? width : '']"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      required: false,
      type: String,
    },
  },
};
</script>

<style scoped>
.action-popup {
  right: 1.5rem;
  top: 2.5rem;
  border: 1px solid #e6e6e6;
  /* box-shadow: 0px 12px 100px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  z-index: 999;
}
</style>
